export class Hours {
  hours?: string | number;
  hoursText?: string;

  constructor(hours?: number | string, hoursText?: string) {
    this.hours = hours;
    this.hoursText = hoursText;
  }
}
